import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Label, Form, Input } from 'reactstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import lmsLogo from '../assets/images/lmsLogo.png';
import { resetPassword } from '../helper/student_helper'; // <-- API: resetPassword(token, newPassword)
import Loader from '../component/Loader/Loader';
import loginBg from '../assets/images/LoginBg.jpg';

const NewPassword = () => {
    const [loader, setLoader] = useState(false);
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [token, setToken] = useState("");

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // extract token from URL query param
        const params = new URLSearchParams(location.search);
        const tokenFromUrl = params.get("token");
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
        } else {
            toast.error("Invalid or missing token.");
            navigate("/login");
        }
    }, [location, navigate]);

    const handleSubmit = async () => {
        try {
            if (!password || !confirmPassword) {
                setSpanDisplay("block");
                return;
            }
            if (password !== confirmPassword) {
                toast.error("Passwords do not match!");
                return;
            }

            setLoader(true);
            const data = await resetPassword({ token, newPassword: password });
            if (data?.success) {
                toast.success(data?.message || "Password reset successful. Please log in.");
                navigate("/login");
            } else {
                toast.error(data?.message || "Password reset failed.");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            {loader && <Loader />}
            <React.Fragment>
                <div
                    style={{
                        backgroundImage: `url(${loginBg})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Container>
                        <Row className="justify-content-center" style={{ width: "90%", margin: "auto" }}>
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden" style={{ boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", border: "none" }}>
                                    <CardBody className="pt-0">

                                        <h3 className="text-center mt-5 mb-2">
                                            <Link to="/" className="d-block auth-logo">
                                                <img src={lmsLogo} alt="logo" height="80" className="auth-logo-dark" />
                                            </Link>
                                        </h3>

                                        <div className="p-3">
                                            <h5 className="text-muted font-size-14 mb-1 text-center">Set New Password</h5>
                                            <p className="text-muted text-center">Enter your new password below.</p>

                                            <Form
                                                className="form-horizontal mt-4"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                    return false;
                                                }}
                                            >
                                                <div className="mb-3">
                                                    <Label htmlFor="password">New Password</Label>
                                                    <Input
                                                        name="password"
                                                        type="password"
                                                        placeholder="Enter new password"
                                                        value={password}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                    />
                                                    {!password && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="confirmPassword">Confirm Password</Label>
                                                    <Input
                                                        name="confirmPassword"
                                                        type="password"
                                                        placeholder="Confirm new password"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                    />
                                                    {!confirmPassword && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                                                </div>

                                                <Row className="mb-3 mt-4">
                                                    <div className="col-12 text-end">
                                                        <button
                                                            className={`btn w-md waves-effect waves-light ${loader ? 'btn-secondary' : 'btn-primary'}`}
                                                            type="submit"
                                                            disabled={loader}
                                                        >
                                                            Update Password
                                                        </button>
                                                    </div>
                                                </Row>
                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>

                                <div className="mt-5 text-center">
                                    © {new Date().getFullYear()} SS <span className="d-none d-sm-inline-block"> - Created By Amass Skill Ventures</span>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        </>
    );
}

export default NewPassword;
